// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListNameType_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListNameType';
  $t: string = 'SagaSchema.ListObjects.ListNameType';

  public static GetMembers(): string[] {
    return ['ListNameTypeId', 'TypeName', 'UseBGColor', 'UseJson'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListNameType_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ListNameTypeId: number = 0;
  public TypeName: string;
  public UseBGColor: boolean = false;
  public UseJson: boolean = false;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.ListNameTypeId;
  }
  get ParentObjId(): any {
    return this.ListNameTypeId;
  }
  set ParentObjId(value: any) {
    this.ListNameTypeId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
